module.exports = "<div>\n    <p-growl [value]=\"msgs\" life=\"1500\"></p-growl>\n</div>\n<router-outlet></router-outlet>"